{
  "LOGIN": {
    "TITLE": "Login to Contact Center",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "john{'@'}companyname.com",
      "ERROR": "Please enter a valid email address"
    },
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login successful",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again.",
      "UNAUTH": "Username or password is incorrect. Please try again.",
      "ACCOUNT_DEACTIVATED": "Your account has been deactivated. Please contact your administrator.",
      "PASSWORD_LOGIN_DISABLED": "Password login is disabled for your account. Please sign in using OAuth (e.g. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Forgot your password?",
    "CREATE_NEW_ACCOUNT": "Create a new account",
    "SUBMIT": "Login"
  }
}
